<template>
    <div>
        <!-- TOP BAR WITH TOTALS + ACTIONS -->
        <div class="go-toolbar">
            <div class="go-totals">
                <div><b>Оптимальна сума:</b> <span>{{ formatMoney(totalOptimal) }}грн.</span></div>
                <div><b>Поточна сума:</b> <span>{{ formatMoney(totalCurrent) }}грн.</span></div>
            </div>
        </div>
        
        <div ref="pos_items" id="positions" style="height:600px;display:block"></div>
        
        <div id="positions_control" style="width: 100%; ">
            <div class="row mt-2">
                <div class="col-2">
                    Оптимальна сума:
                </div>
                
                <div class="summ_opt col-3">{{ formatMoney(totalOptimal) }}грн.</div>
                <div class="col-3">
                    <div class="btn  btn-outline-primary btn_save_xls_positions waves-effect waves-themed" style="width:inherit; text-transform: uppercase;"  @click="onExportNomenclatureXls">
                        Номенклатура .xls
                    </div>
                </div>
                
                <div class="col-4">
                    <div class="btn btn-primary btn_new_tender uppercase waves-effect waves-themed" style="width:inherit; text-transform: uppercase;" @click="onNewTour">
                        Новий тур
                    </div>
                </div>
            </div>
            
            <div class="row mt-2">
                <div class="col-2">
                    Поточна сума:
                </div>
                <div class="summ_current col-3" >
                    {{ formatMoney(totalCurrent) }}грн.
                </div>
                
                <div class="col-3">
                    <div class="btn btn-outline-primary btn_save_xls_positions_val waves-effect waves-themed"
                         style="width:inherit; text-transform: uppercase;" @click="onExportInCurrencyXls">
                        В валюті .xls
                    </div>
                </div>
                
                <div class="col-4">
                    <div class="btn btn-outline-dark btn_rating_company waves-effect waves-themed"style="width:inherit; text-transform: uppercase;" @click="onContractorScores">
                        Оцінки контрагентів
                    </div>
                </div>
            </div>
            
            <div class="row mt-2">
                <div class="col-2">
                
                </div>
                <div class="col-3">
                
                </div>
                <div class="col-3">
                    <div class="btn btn-outline-primary btn_save_xls_company waves-effect waves-themed" data-id="1978" style="width:inherit; text-transform: uppercase;" @click="onContractorsXls">
                        Контрагенти .xls
                    </div>
                </div>
          
                <div class="col-4">
                    <div class="btn btn-outline-primary btn_add_app waves-effect waves-themed"
                         style="width:inherit; text-transform: uppercase;" @click="onAddParticipant">
                        Додати Учасника
                    </div>
                </div>
            </div>
            
            <div class="row mt-2" style="display: none">
                <div class="col-2">
                    Переплата:
                </div>
                <div class="summ_ower col-10" value="0">0.00грн.</div>
            </div>
            
            <div class="row mt-2">
                <div class="col-2">
                
                </div>
                <div class="col-3">
                
                </div>
                <div class="col-3">
                    <div class="btn btn-outline-primary btn_save_xls_positions_val2 waves-effect waves-themed" data-id="1978" style="width:inherit; text-transform: uppercase;"  @click="onSumInCurrencyXls">
                        Сума в валюті .xls
                    </div>
                </div>
                <div class="col-4">
                
                </div>
            </div>
        </div>
    </div>
    
    <protocol_add_user @users_selected="this.pushUsers" id = "users-modal" name_ = ' учасників' :users="subscribes"></protocol_add_user>
    
</template>

<script>
import * as W2 from 'w2ui'
import protocol_add_user from "../add_user/protocol_add_user.vue";
window.w2ui    = W2.w2ui
window.w2grid  = W2.w2grid
window.w2utils = W2.w2utils
window.w2popup = W2.w2popup
window.$       = window.jQuery

export default {
    name: 'protocol_inside_positions',
    components: {protocol_add_user},
    props: { protocol: { type: Object, required: true } },
    
    data() {
        return {
            show_user_choice : false,
            totalOptimal: 0,
            totalCurrent: 0,
        }
    },
    
    mounted() {
        this.tryInit()
    },
    
    computed: {
        position_data() { return this.protocol?.positions || null },
        columns()       { return this.position_data?.columns || [] },
        columnGroups()  { return this.position_data?.columnGroups || [] },
        records()       { return this.position_data?.records || [] },
        winners()       { return this.protocol?.winners || [] },
        
        
        subscribes : {
            
            get() {
           
               let res = this.members.map(item => {
                   item.user_id =  parseInt(item.author_id);
                   return item;
               });
               return res;
               // return this.tender.subscribes_in;
            },
            
            set(val) {
                console.log('new_subscribes',val);
                this.$emit('changeAtr', {
                    field: 'subscribes_in',
                    value: this.subscribes
                })
                this.tender.subscribes_in = val;
            }
        },
        
        
        members() {
            return this.protocol?.members || [];
        }
        
    },
    
    methods: {
        
        async pushUsers(event) {
            console.log('event',event);
           // this.subscribes = event?.users || [];
            event.protocol_id = this.protocol.id;
            
            try {
                const { data } = await axios.post('/internal/protocol/add_contragents',{event})
                this.items = []
                if (data?.status === 'operation_success') {
                    IMC_CORE.snackbar('Додано');
                    EventBus.$emit('application:updated');
                }
                
            } catch (e) {
            
            }
           
           
           
        },
        
        onNewTour()  {
            console.log('NEW TOUR')
            EventBus.$emit('show_new_tour');
        },
        
        onExportNomenclatureXls()   {
            console.log('EXPORT: nomenclature.xls');
            const protocol_id = this.protocol.id;
            window.open(`/internal/protocol/export_excel?protocol_id=${protocol_id}`, '_blank')
        },
        onExportInCurrencyXls()     {
            console.log('EXPORT: onExportInCurrencyXls.xls')
            const protocol_id = this.protocol.id;
            window.open(`/internal/protocol/export_excel_val?protocol_id=${protocol_id}`, '_blank')
          
        },
        
        //Оцінки
        onContractorScores()        {
            console.log('OPEN: contractor scores');
            EventBus.$emit('show_rating_protocol',this.protocol.id);
        },
        
        //Контрагенти
        onContractorsXls()          {
            console.log('EXPORT: in-currency.xls')
            const protocol_id = this.protocol.id;
            window.open(`/internal/protocol/export_excel_by_company?protocol_id=${protocol_id}`, '_blank')
         
        },
        
        
        onAddParticipant()          {
            this.show_user_choice = true;
            console.log('ADD: participant')
            EventBus.$emit('choose_contragents');
        },
        
        
        //Сума валюті
        onSumInCurrencyXls()        {
            console.log('EXPORT: in-onSumInCurrencyXls.xls')
            const protocol_id = this.protocol.id;
            window.open(`/internal/protocol/export_excel_val2?protocol_id=${protocol_id}`, '_blank')
          
        },
        
        tryInit() {
            if (!this.$refs.pos_items) return
            if (w2ui.positions) w2ui.positions.destroy()
            this.fixNumber()
            
            window.$().w2grid({
                name: 'positions',
                header: 'Пропозиції',
                show: { header: true, lineNumbers: true, toolbar: true, footer: true },
                columnGroups: this.columnsFix(this.columnGroups),
                columns:      this.columnsFix(this.columns),
                records:      this.columnsFix(this.records),
            })
            
            window.$(this.$refs.pos_items).w2render('positions')
            w2ui.positions.show.header = true
            w2ui.positions.refresh()
            
            this.addToolbarToggles()
            this.renderMiniGridsFromWinners()
            this.recalcFromWinners()
        },
        
        // ---------- BUILD FROM WINNERS ----------
        buildBucketsFromWinners() {
            const rowsById = {};
            (this.records || []).forEach(r => { rowsById[String(r.id ?? r.recid)] = r });
            
            const byApp = new Map();
            
            (this.winners || []).forEach(w => {
                const appId  = String(w.app || '').replace(/^app/, '');
                const bucket = byApp.get(appId) || {
                    id: 'app' + appId,
                    title: this.findAppTitle(appId),
                    records_push: [],
                };
                
                (w.win || []).forEach(winRow => {
                    const posId = String(winRow.tender_position_id || winRow.id || '');
                    const base  = rowsById[posId];
                    if (!base) return;
                    
                    const qty   = parseFloat(winRow.quantity || 0) || 0;
                    const price = parseFloat(base['Price_' + appId] ?? 0) || 0;
                    
                    const rec = {
                        id: base.id ?? base.recid,
                        recid: base.recid ?? base.id,
                        min: base.min ?? 0,
                    };
                    
                    rec.title =
                        base.title ??
                        base.position ??
                        base.name ??
                        base['Позиція'] ??
                        '';
                    
                    rec['quantity_protocol' + appId] = qty.toFixed(2);
                    rec['Price_' + appId]            = price;
                    rec['Sum_' + appId]              = +(qty * price).toFixed(2);
                    
                    const pvKey = 'price_val_' + appId;
                    if (pvKey in base) {
                        rec[pvKey] = base[pvKey];
                    } else {
                        rec[pvKey] = '';
                    }
                    
                    bucket.records_push.push(rec);
                });
                
                if (bucket.records_push.length) byApp.set(appId, bucket);
            });
            
            return Array.from(byApp.values());
        },
        
        
        renderMiniGridsFromWinners() {
            const buckets = this.buildBucketsFromWinners()
            
            for (const b of buckets) {
                const appId = String(b.id).replace(/^app/, '')
                const name  = b.id
                const title = b.title || this.findAppTitle(appId)
                
                if (w2ui[name]) w2ui[name].destroy()
                
                const need = new Set([
                    'id', 'title',
                    'quantity_protocol' + appId,
                    'app' + appId,
                    'price_val_' + appId,
                ])
                const cols = (this.columns || []).filter(c => need.has(c.field))
                
                window.$().w2grid({
                    name,
                    header: title,
                    show: { header: true, lineNumbers: true, toolbar: true, footer: true },
                    columns: cols.map(c => ({ ...c })),
                    records: [],
                })
                
                const rows = b.records_push.map(r => ({ ...r }))
                rows.forEach(r => {
                    const price = parseFloat(r['Price_' + appId] ?? 0) || 0
                    const qty   = parseFloat(r['quantity_protocol' + appId] ?? 0) || 0
                    const sum   = +(price * qty).toFixed(2)
                    r['Sum_' + appId] = sum
                    
                    const isMin = price === parseFloat(r.min || 0)
                    r['app' + appId] = isMin
                        ? `<div style="background:#008000;color:#fff;padding:2px;">${sum}</div>`
                        : `<div style="padding:2px;">${sum}</div>`
                })
                
                w2ui[name].add(rows)
                
                const container = document.getElementById('protocol_winners');
                if (!container) return;
                
                const wrapId = 'wgrid_' + name; // чтобы не пересекалось с name
                let wrap = document.getElementById(wrapId);
                if (!wrap) {
                    wrap = document.createElement('div');
                    wrap.id = wrapId;
                    wrap.style.cssText = 'width:100%;height:450px;margin-top:10px;';
                    container.appendChild(wrap);
                }
                const h = w2ui[name].records.length * w2ui[name].recordHeight + 150 + 'px';
                wrap.style.height = h;
                window.$('#' + wrapId).w2render(name);
            }
        },
        
        // --- пересчёт + тоталы ---
        recalcFromWinners() {
            if (!w2ui.positions) return
            
            const buckets = this.buildBucketsFromWinners()
            const selected = {}
            
            const collect = (appId, rows) => {
                const pKey = 'Price_' + appId
                const qKey = 'quantity_protocol' + appId
                const sKey = 'Sum_' + appId
                
                ;(rows || []).forEach(r => {
                    const id  = r.id ?? r.recid
                    const qty = parseFloat(r[qKey] ?? 0) || 0
                    const pr  = parseFloat(r[pKey] ?? 0) || 0
                    const sum = +(qty * pr).toFixed(2)
                    r[sKey] = sum
                    
                    if (!selected[id]) selected[id] = { summ: 0, quantity_protocol: 0, byApp: {} }
                    selected[id].summ += sum
                    selected[id].quantity_protocol += qty
                    
                    if (!selected[id].byApp[appId]) selected[id].byApp[appId] = { sum: 0, qty: 0, isMin: false }
                    selected[id].byApp[appId].sum += sum
                    selected[id].byApp[appId].qty += qty
                    
                    const isMin = pr === parseFloat(r.min || 0)
                    selected[id].byApp[appId].isMin = selected[id].byApp[appId].isMin || isMin
                })
            }
            
            buckets.forEach(b => {
                const appId = String(b.id).replace(/^app/, '')
                collect(appId, b.records_push || [])
            })
            
            // очистка и применение к основному гриду
            ;(w2ui.positions.records || []).forEach(item => {
                const baseQty = parseFloat(item.quantity || 0) || 0
                
                Object.keys(item).forEach(k => {
                    if (/^quantity_protocol\d+$/.test(k)) item[k] = 0
                    if (/^Sum_\d+$/.test(k))              item[k] = 0
                    if (/^app\d+$/.test(k))               item[k] = ''
                })
                item.quantity_protocol = baseQty
                
                const agg = selected[item.id]
                if (!agg) return
                
                const used = parseFloat(agg.quantity_protocol || 0) || 0
                item.quantity_protocol = Math.max(0, baseQty - used)
                
                Object.entries(agg.byApp).forEach(([appId, v]) => {
                    const qKey = 'quantity_protocol' + appId
                    const sKey = 'Sum_' + appId
                    const aKey = 'app' + appId
                    
                    item[qKey] = (item[qKey] || 0) + (v.qty || 0)
                    item[sKey] = +(v.sum || 0).toFixed(2)
                    
                    const valStr = item[sKey].toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                    item[aKey] = v.isMin
                        ? `<div style="cursor:pointer;background-color:green;color:white;padding:2px;">${valStr}</div>`
                        : `<div style="cursor:pointer;padding:2px;">${valStr}</div>`
                })
            })
            
            // тоталы:
            this.totalCurrent = Object.values(selected).reduce((s, v) => s + (v.summ || 0), 0)
            
            // оптимальная: мин. Price_* по каждой позиции * её базовая quantity
            this.totalOptimal = (w2ui.positions.records || []).reduce((acc, item) => {
                const baseQty = parseFloat(item.quantity || 0) || 0
                let minPrice = Infinity
                Object.keys(item).forEach(k => {
                    if (/^Price_\d+$/.test(k)) {
                        const p = parseFloat(item[k] ?? 0) || 0
                        if (p > 0 && p < minPrice) minPrice = p
                    }
                })
                if (!isFinite(minPrice)) minPrice = 0
                return acc + +(minPrice * baseQty).toFixed(2)
            }, 0)
            
            try { w2ui.positions.refresh() } catch (e) {}
        },
        
        // ---------- UI helpers ----------
        addToolbarToggles() {
            const add = (id, text) =>
                w2ui.positions.toolbar.add({
                    type: 'check', id, text, icon: 'w2ui-icon-columns',
                    onClick: (ev) => this.toggleCols(ev.object.id)
                })
            
            add('quantity_',         '"Кількість"')
            add('quantity_protocol', '"Кількість Протокол"')
            add('price',             '"Ціна(грн)"')
            add('price_val_',        '"Ціна(валюта)"')
            add('app',               '"Сума(грн)"')
            add('comment',           '"Коментар"')
            
            ;['comment','quantity_protocol','price_val_'].forEach(id => {
                w2ui.positions.toolbar.set(id, { checked: true })
                this.toggleCols(id)
            })
            w2ui.positions.toolbar.refresh()
        },
        
        toggleCols(prefix) {
            const re = new RegExp(prefix + '(\\d+)')
            w2ui.positions.columns.forEach(c => {
                if (re.test(c.field)) c.hidden = !c.hidden
            })
            w2ui.positions.refreshBody()
            w2ui.positions.resizeRecords()
        },
        
        columnsFix(items = []) {
            return items.map(it =>
                (Object.prototype.hasOwnProperty.call(it, 'caption') ? { ...it, text: it.caption } : it)
            )
        },
        
        findAppTitle(appId) {
            const f = 'app' + appId
            const col = (this.columns || []).find(c => c.field === f)
            return col?.app_title || col?.caption || col?.text || ('Контрагент ' + appId)
        },
        
        fixNumber() {
            if (window.w2utils?.formatNumber) {
                const orig = w2utils.formatNumber
                w2utils.formatNumber = function (val, fraction, useGrouping) {
                    if (useGrouping !== true && useGrouping !== false) useGrouping = false
                    return orig.call(this, val, fraction, useGrouping)
                }
            }
        },
        
        formatMoney(n) {
            const v = Number(n || 0)
            return v.toLocaleString('uk-UA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },
    },
}
</script>

<style scoped>
.go-toolbar {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;
}
.go-totals > div { margin-bottom: 6px; }
.go-actions { display: grid; grid-auto-flow: row; gap: 8px; }
.go-btn {
    padding: 10px 14px;
    border: 1px solid #9b88c4;
    border-radius: 6px;
    background: transparent;
    cursor: pointer;
}
.go-btn:hover { filter: brightness(0.95); }
.go-primary { background: #7f68b7; color: #fff; border-color: #7f68b7; }
@media (min-width: 900px) {
    .go-actions { grid-auto-flow: column; grid-auto-columns: 1fr; }
}
</style>
